import type { ReactNode } from 'react'
import { appOrigin, currentFace, currentProduct } from '../lib/public-router'
import { Button } from './Button'

/**
 * The way in, wherever a public page offers one.
 *
 * On a product's public site it is a LINK to the product's app — an address, so
 * it opens in a tab and can be copied — and the app signs a person in there if
 * they are not already. Everywhere else (the platform's own site, a
 * congregation's own domain) it opens the sign-in screen in place, which is an
 * act rather than a destination and so stays a button. The words and where they
 * lead are decided here together, so the two cannot disagree.
 *
 * Offered only where the page offers a way in at all: `onSignIn` absent means
 * none is offered.
 */
export function WayIn({
  onSignIn,
  variant,
  className,
}: {
  onSignIn?: () => void
  variant?: 'default' | 'quiet' | 'secondary'
  className?: string
}): ReactNode {
  if (!onSignIn) return null
  const product = currentProduct()
  if (product && currentFace() === 'public')
    return (
      <Button
        variant={variant}
        className={className}
        render={<a href={appOrigin(product)} />}
      >
        Go to app
      </Button>
    )
  return (
    <Button variant={variant} className={className} onClick={onSignIn}>
      Sign in
    </Button>
  )
}
